/**
 * User Microservice
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export type UserAliasPatternPartSelectionCriteria = 'AllCharacters' | 'FirstNCharacters' | 'LastNCharacters' | 'SimpleReplacement' | 'RegexReplacement' | 'NotApplicable';

export const UserAliasPatternPartSelectionCriteria = {
    AllCharacters: 'AllCharacters' as UserAliasPatternPartSelectionCriteria,
    FirstNCharacters: 'FirstNCharacters' as UserAliasPatternPartSelectionCriteria,
    LastNCharacters: 'LastNCharacters' as UserAliasPatternPartSelectionCriteria,
    SimpleReplacement: 'SimpleReplacement' as UserAliasPatternPartSelectionCriteria,
    RegexReplacement: 'RegexReplacement' as UserAliasPatternPartSelectionCriteria,
    NotApplicable: 'NotApplicable' as UserAliasPatternPartSelectionCriteria
};

